module.exports = __webpack_public_path__ + "assets/img/dbba7d6a04370f2029a833f9337f02f0.svg";